import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withFormikField } from 'utils/formik';
import * as http from 'utils/http';
import ShipmentModalAssignment from 'components/ShipmentModalAssignment';
import { Spacer } from '@ontruck/orc';

const DriverVehicleSection = ({ form }) => {
  const { values } = form;

  const { driver } = values;

  const [requestedDriver, setRequestedDriver] = useState(null);

  useEffect(() => {
    if (typeof driver !== 'string') {
      setRequestedDriver(null);
      return;
    }

    const getDriver = async () => {
      try {
        const driverData = await http.get(driver);
        setRequestedDriver(driverData);
      } catch (err) {
        console.error(err);
      }
    };

    getDriver();
  }, [driver]);

  return (
    <Fragment>
      {!!requestedDriver && (
        <Spacer mBottom="S">
          <strong>Current driver</strong>: {requestedDriver.contact_name}
        </Spacer>
      )}

      <ShipmentModalAssignment
        show={true}
        onTop
        driver={null}
        vehicle={null}
        trailer={null}
        renderInModal={false}
        onChange={({ driver, vehicles }) => {
          form.setFieldValue('driver', driver);
          form.setFieldValue('vehicles', vehicles);
        }}
      />
    </Fragment>
  );
};

DriverVehicleSection.propTypes = {
  form: PropTypes.object.isRequired,
};

export default withFormikField(DriverVehicleSection);
